<template>
  <div style="display: flex;line-height: 60px;height: 100%">

      xxx公司
  </div>
</template>

<script>
export default {
  name: "Foot",

  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>
</style>
